import {
  Box, Button,
} from '@mui/material';
import { useMemo, useState } from 'react';
import ImageModalPopUp from './ImageModalPopUp';

interface ImageModalProps {
  images: { id: number, url: string }[]
  title?: string
  children?: JSX.Element
  disabled?: boolean
  absoluteButton?: boolean
  handleOnConfirm: (url: string) => void
  showTitle?: boolean
}

const ImageModal = (props: ImageModalProps) => {
  const {
    images, title, children, disabled, absoluteButton = true, handleOnConfirm, showTitle = true,
  } = props;
  const [modalShow, setModalShow] = useState(false);

  const imageItems = useMemo(() => images.map((img) => ({
    url: `${process.env.REACT_APP_API_URL}/${img.url}`,
    id: img.id,
  })), [images]);

  const handleSave = (selectedImageId: number) => {
    const target = imageItems.find((item) => item.id === selectedImageId);
    handleOnConfirm(target.url);
    setModalShow(false);
  };

  const buttonStyle = useMemo(() => {
    if (absoluteButton) {
      return {
        position: 'absolute',
        backgroundColor: '#5555558A',
        top: 10,
        left: 10,
        zIndex: 1,
      };
    }
    return {
      backgroundColor: '#5555558A',
    };
  }, [absoluteButton]);

  return (
    <>
      {children ? (
        <Box
          sx={{
            height: '100%',
            maxHeight: '100%',
            width: '100%',
            maxWidth: '100%',
          }}
          onClick={(event) => {
            if (disabled) return;
            setModalShow(true);
            event.stopPropagation();
          }}
        >
          {children}
        </Box>
      ) : (
        showTitle && (
          <Button
            onClick={(event) => {
              setModalShow(true);
              event.stopPropagation();
            }}
            variant="contained"
            component="label"
            sx={buttonStyle}
          >
            {title || '画像を選択する'}
          </Button>
        )
      )}
      <ImageModalPopUp
        images={images}
        handleSave={handleSave}
        modalShow={modalShow}
        onClose={(event) => {
          setModalShow(false);
          event.stopPropagation();
        }}
      />
    </>
  );
};

export default ImageModal;
